// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1mwMk","alertIcon":"ConfirmModal_alertIcon__1MoVX"};